/** 
 * api接口的统一出口
 */

import code from '@/api/modules/code';

// 导出接口
export default { 
	code
}
// this.$api.code.tracelist({code:'165002072025'});